import { BASE_URL } from "../constants/Endpoints"
import axios from "axios";

export class DashboardService {
    base(path) { return `${BASE_URL}/${path}` }

    async getDashboardSummary(params = {}, signal) {
        const config = {
            params,
            signal,
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (Array.isArray(params[key])) {
                        searchParams.append(key, params[key].join(','));
                    } else {
                        searchParams.append(key, params[key]);
                    }
                });
                return searchParams.toString();
            }
        };
        const [stats, series, revenueByState] = await Promise.all([
            axios.get(this.base('dashboard/stats'), config).then(r => r.data),
            axios.get(this.base('dashboard/new-opportunities-count'), config).then(r => r.data),
            axios.get(this.base('dashboard/opportunity-revenue-by-state'), config).then(r => r.data),
        ]);
        return {
            stats,
            series,
            revenue_by_state: revenueByState,
        };
    }

    async getNewOpportunitiesCount(params = {}) {
        const url = this.base(`dashboard/new-opportunities-count`);
        return await axios.get(url, { 
            params,
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (Array.isArray(params[key])) {
                        searchParams.append(key, params[key].join(','));
                    } else {
                        searchParams.append(key, params[key]);
                    }
                });
                return searchParams.toString();
            }
        }).then(r => r.data);
    }

    async getDashboardStats(params = {}) {
        const url = this.base(`dashboard/stats`);
        return await axios.get(url, { 
            params,
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (Array.isArray(params[key])) {
                        searchParams.append(key, params[key].join(','));
                    } else {
                        searchParams.append(key, params[key]);
                    }
                });
                return searchParams.toString();
            }
        }).then(r => r.data);
    }

    async getDropdownOptions() {
        const url = this.base(`dashboard/dropdown-options`);
        return await axios.get(url).then(r => r.data);
    }

    async getOpportunityRevenueByState(params = {}) {
        const url = this.base(`dashboard/opportunity-revenue-by-state`);
        return await axios.get(url, { 
            params,
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (Array.isArray(params[key])) {
                        searchParams.append(key, params[key].join(','));
                    } else {
                        searchParams.append(key, params[key]);
                    }
                });
                return searchParams.toString();
            }
        }).then(r => r.data);
    }

    async getOpportunitiesByState(params = {}) {
        const url = this.base(`dashboard/opportunities-by-state`);
        return await axios.get(url, { 
            params,
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (Array.isArray(params[key])) {
                        searchParams.append(key, params[key].join(','));
                    } else {
                        searchParams.append(key, params[key]);
                    }
                });
                return searchParams.toString();
            }
        }).then(r => r.data);
    }

    async downloadDashboardReport(params = {}) {
        const url = this.base(`dashboard/report`);
        return await axios.get(url, {
            params,
            responseType: 'blob',
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (Array.isArray(params[key])) {
                        searchParams.append(key, params[key].join(','));
                    } else {
                        searchParams.append(key, params[key]);
                    }
                });
                return searchParams.toString();
            }
        });
    }

    async getOpportunitiesByDate(date, params = {}) {
        const url = this.base(`dashboard/opportunities-by-date`);
        return await axios.get(url, { 
            params: { date, ...params },
            paramsSerializer: params => {
                const searchParams = new URLSearchParams();
                Object.keys(params).forEach(key => {
                    if (Array.isArray(params[key])) {
                        searchParams.append(key, params[key].join(','));
                    } else {
                        searchParams.append(key, params[key]);
                    }
                });
                return searchParams.toString();
            }
        }).then(r => r.data);
    }
}
